import { Grid } from "@material-ui/core";
import React, { FunctionComponent, useContext } from "react";
import { RouteContext } from "./route-context";
import { EditRouteStopsContextProvider } from "./edit-route-stops.context";
import { RouteDetailsHeader } from "./route-details-header";
import { RouteDetailsContent } from "./route-details-content";

interface IRouteDetailsProps {
  routeId: string;
}

export const RouteDetails: FunctionComponent<IRouteDetailsProps> = (props) => {
  const { routeId } = props;
  const { route } = useContext(RouteContext);

  return (
    <EditRouteStopsContextProvider stops={route?.stops || []} routeId={routeId}>
      <Grid container direction="column" spacing={2}>
        <RouteDetailsHeader />
        <RouteDetailsContent />
      </Grid>
    </EditRouteStopsContextProvider>
  );
};
